import { injectable } from 'inversify';
import Mime from 'mime/lite';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { ObjectManager } from '../../../concepts/objects';
import { resolve } from '../../Container';
import { EditorSession } from '../EditorSession';
import { ContentPayload } from './ContentPayload';
import { ContentProcessor } from './ContentProcessor';

const safeParseJson = (text: string) => {
    try {
        return JSON.parse(text);
    }
    catch {
        return null;
    }
};

@injectable()
export class JsonDataProcessor implements ContentProcessor {

    @resolve(CommandDispatcher) dispatch!: CommandDispatcher;
    @resolve(EditorSession) session!: EditorSession;
    @resolve(ObjectManager) objects!: ObjectManager;

    public readonly supportedTypes = Object.freeze([
        Mime.getType('json')
    ]);

    public async process(payload: ContentPayload): Promise<boolean | ContentPayload> {

        // Try read text
        const textData = await payload.getDataAsText();
        if (!textData) return false;

        // Try parse
        const objData = safeParseJson(textData);
        if (!objData) return false;

        // For now we just support Deqo Data Tuples, so detect and return if appropriate
        if (Array.isArray(objData) && objData[0] === 'ddt:v1.1') {
            return Promise.resolve(ContentPayload.derive(payload, 'x/deqo-tuple', objData));
        }
        if (Array.isArray(objData) && objData[0] === 'dst:v1.0') {
            return Promise.resolve(ContentPayload.derive(payload, 'x/deqo-styles', objData));
        }

        // TODO: Support more intelligent JSON handling here

        // Otherwise fail
        return Promise.resolve(false);

    }
}
